let projectJson = require('../data/projects.json');

document.addEventListener("DOMContentLoaded", function(event) { 
    generateWinnersData();
});

window.onload = () => {
    // handlePageLoaded();
};

function handlePageLoaded(){
    // document.getElementsByClassName("loading-screen")[0].style.display = "none";
    // document.getElementById("section-programpartners").style.display = "block";
}

async function generateWinnersData() {

    let top15Winners = document.querySelector("#top15");
    let popularWinners = document.querySelector("#popular");
    let xilnexWinners = document.querySelector("#xilnex");
    let usmWinners = document.querySelector("#usm");
    let businessWinners = document.querySelector("#business");
    let container = '';

    projectJson.forEach(project => {

        switch (project.type) {
            case "top15":
                container = top15Winners;
                break;

            case "popular":
                container = popularWinners;
                break;

            case "xilnex":
                container = xilnexWinners;
                break;

            case "usm":
                container = usmWinners;
                break;

            case "business":
                container = businessWinners;
                break;
                
        
        }

      container.innerHTML += `
        <div class="d-flex flex-wrap justify-content-center align-self-stretch" id="award-cards" data-aos="fade-up" data-aos-duration="500" >
            <div class="card award-card m-3" style="width: 300px;">
                <div class="d-flex justify-content-center">
                <img src="https://data.vhackusm.com/winners/${project.code}.jpg" class="mt-3 award-image" alt="Photo of ${project.name}">
                </div>
                <div class="card-body p-4 pb-2">
                <h5 class="card-title fw-bold text-center text-white">${project.name}</h5>
                <p class="card-text text-center m-0 award-tagline text-white py-3">${project.tagline}</p>
                </div>
                <footer class="d-flex justify-content-center pb-4 ratio ratio-16x9">
                <iframe width="420" height="315"
                src="${project.projectlink}">
                </iframe>
                </footer>
            </div>
        </div>
      `
    })
}
